import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2c58e95c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Globale Berechtigungen", -1))
const _hoisted_2 = { class: "checkbox-wrapper" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Chatbots erstellen")
const _hoisted_4 = { class: "checkbox-wrapper" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Chatbots bearbeiten")
const _hoisted_6 = { class: "checkbox-wrapper" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Chatbots löschen")
const _hoisted_8 = { class: "checkbox-wrapper" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Posteingang nutzen")
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Rollen", -1))
const _hoisted_11 = { class: "checkbox-wrapper" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Marketing")
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_14 = /*#__PURE__*/_createTextVNode("(Dashboard, Analyse, Zielgruppen & Broadcasts)")
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Chatbots", -1))
const _hoisted_16 = { class: "checkbox-wrapper" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Zugriff auf alle Chatbots", -1))
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Abbrechen")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("Änderungen speichern")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_md_checkbox = _resolveComponent("md-checkbox")!
  const _component_md_button = _resolveComponent("md-button")!
  const _component_md_modal = _resolveComponent("md-modal")!

  return (_openBlock(), _createBlock(_component_md_modal, {
    ref: "modal",
    title: "Berechtigungen verwalten"
  }, {
    body: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_md_checkbox, {
          modelValue: _ctx.grantedPermissions,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.grantedPermissions) = $event)),
          value: "cc.global.create"
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_md_checkbox, {
          modelValue: _ctx.grantedPermissions,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.grantedPermissions) = $event)),
          value: "cc.global.edit"
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_md_checkbox, {
          modelValue: _ctx.grantedPermissions,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.grantedPermissions) = $event)),
          value: "cc.global.delete"
        }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_md_checkbox, {
          modelValue: _ctx.grantedPermissions,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.grantedPermissions) = $event)),
          value: "cc.global.inbox"
        }, {
          default: _withCtx(() => [
            _hoisted_9
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _hoisted_10,
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_md_checkbox, {
          modelValue: _ctx.grantedPermissions,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.grantedPermissions) = $event)),
          value: "cc.roles.marketing"
        }, {
          default: _withCtx(() => [
            _hoisted_12,
            _hoisted_13,
            _hoisted_14
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _hoisted_15,
      _createElementVNode("div", _hoisted_16, [
        _createVNode(_component_md_checkbox, {
          modelValue: _ctx.grantedPermissions,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.grantedPermissions) = $event)),
          value: "cc.chatbots.any"
        }, {
          default: _withCtx(() => [
            _hoisted_17
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chatbots, (chatbot) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "checkbox-wrapper",
          key: chatbot.id
        }, [
          _createVNode(_component_md_checkbox, {
            modelValue: _ctx.grantedPermissions,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.grantedPermissions) = $event)),
            value: 'cc.chatbots.' + chatbot.id
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(chatbot.name), 1)
            ]),
            _: 2
          }, 1032, ["modelValue", "value"])
        ]))
      }), 128))
    ]),
    actions: _withCtx(() => [
      _createVNode(_component_md_button, {
        variant: "text",
        grey: "",
        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.close()))
      }, {
        default: _withCtx(() => [
          _hoisted_18
        ]),
        _: 1
      }),
      _createVNode(_component_md_button, {
        variant: "filled",
        onClick: _ctx.submit
      }, {
        default: _withCtx(() => [
          _hoisted_19
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _: 1
  }, 512))
}